import React, { Component, ReactNode } from 'react';
import i18n from 'i18n';
import { Alert, ProgressBar } from '..';

import ShowStatusMessage from '../../xcipio/warrants/forms/updateWarrant/show-status';
import './style.scss';

interface IProgressBarIndicatorProps {
  counter: number,
  errors: Array<string>,
  handleConfirm: any,
  inProgress: boolean,
  isOpen: boolean,
  totalSelected: number,
  totalProcessed: number,
}

class ProgressBarIndicator extends Component<IProgressBarIndicatorProps> {
  renderProgress(): ReactNode {
    const { totalProcessed, totalSelected } = this.props;

    if (totalProcessed < totalSelected) {
      return (
        <span dangerouslySetInnerHTML={{ __html: i18n.t('progressBar.partialProgress', { totalProcessed, totalSelected }) }} />
      );
    }

    return i18n.t('progressBar.completed');
  }

  renderDetails(): ReactNode {
    const { counter, errors } = this.props;

    if (counter === 0 && errors.length === 0) {
      return null;
    }

    if (counter > 0 && errors.length === 0) {
      return <span dangerouslySetInnerHTML={{ __html: i18n.t('progressBar.succeeded', { counter }) }} />;
    }

    if (counter === 0 && errors.length > 0) {
      return <span dangerouslySetInnerHTML={{ __html: i18n.t('progressBar.failed', { errors: errors.length }) }} />;
    }

    return <span dangerouslySetInnerHTML={{ __html: i18n.t('progressBar.mixed', { counter, errors: errors.length }) }} />;
  }

  render(): ReactNode {
    const {
      isOpen,
      handleConfirm,
      inProgress,
      errors,
      totalSelected,
      totalProcessed,
    } = this.props;

    return (
      <Alert
        isOpen={isOpen}
        handleConfirm={handleConfirm}
        confirmButtonText={inProgress ? i18n.t('common.button.cancel') : i18n.t('common.button.ok')}
        style={{
          width: '550px',
          minWidth: '550px',
          minHeight: errors.length ? '350px' : 'auto',
        }}
      >
        <div className="bulk-content-container">
          <div>
            <p>
              {this.renderProgress()}
              {' '}
              {this.renderDetails()}
            </p>
          </div>
          <ProgressBar
            value={totalProcessed / totalSelected}
            key={totalProcessed}
            animate={inProgress}
            className="bulk-progress-bar"
          />
          {errors.length !== 0 && (
            <ShowStatusMessage
              isDialog
              hasErrors
              msgs={errors}
              className="bulk-action"
            />
          )}
        </div>
      </Alert>
    );
  }
}

export default ProgressBarIndicator;
